import React, { FC } from 'react';
import './Layout.scss';
import classnames from 'classnames';
import { LayoutProps } from './models';
import Seo from '../Seo';

const Layout: FC<LayoutProps> = ({ className, children, language, pageTitle = '', ...rest }) => {
  const rtlLanguages = ['ar'];

  return (
    <div
      className={classnames('layout', className, language, {
        'text-direction--rtl': rtlLanguages.includes(language),
      })}
      {...rest}
    >
      <Seo language={language} pageTitle={pageTitle} />
      <main id="main-content" className="layout__main">
        {children}
      </main>
    </div>
  );
};

export default Layout;
